<template>
    <el-dialog title="Ajouter des accessoires" v-loading="loader" :visible.sync="display" width="90%">
        <el-alert v-if="error" :title="errorMessage" type="error" show-icon>
        </el-alert>

        <h5>Rechercher des produits à ajouter</h5>
        <div class="row">
            <div class="col-lg-7">
                <el-input @keyup.enter.native="search" placeholder="Produit" v-model="q"></el-input>
            </div>
            <div class="col-lg-5">
                <el-button type="primary" @click.prevent="search" plain>Rechercher</el-button>
                <el-button type="default" @click.prevent="reset" plain>Reset</el-button>
                <el-button v-if="finded.length" type="default" @click.prevent="addAll" plain>Tous ajouter</el-button>
            </div>
        </div>
        <el-table v-loading="loading" style="width: 100%" :data="finded" stripe>
            <el-table-column prop="visuel" width="55">
                <template slot-scope="scope">
                    <el-badge :value="scope.row.images.length" class="item">
                        <span class="avatar"  v-if="scope.row.image" :style="{backgroundImage: 'url(\'/ic/thumbnail/'+scope.row.image.path+'\')'}"></span>
                        <span class="avatar"  v-else-if="scope.row.images.length" :style="{backgroundImage: 'url(\'/ic/thumbnail/'+scope.row.images[0].path+'\')'}"></span>
                        <span class="avatar"  v-else></span>
                    </el-badge>
                </template>
            </el-table-column>
            <el-table-column prop="shop_id" label="Ref Speedway / ID" >
                <template slot-scope="scope">
                    {{ scope.row.shop_id }}
                </template>
            </el-table-column>
            <el-table-column prop="name" label="Titre"  >
                <template slot-scope="scope">
                    <span v-if="scope.row.feature_type">[{{scope.row.feature_type}}] </span>{{ scope.row.name }}
                </template>
            </el-table-column>
            <el-table-column prop="external_ref" label="Ref fournisseur"  >
                <template slot-scope="scope">
                    {{ scope.row.mf_prefixe }} / {{ scope.row.external_ref }}
                    <span v-if="scope.row.base_ref">
                        <br>
                        ({{ scope.row.base_ref }}<template v-if="scope.row.color_code"> / {{scope.row.color_code}}</template>)
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="actions" >
                <template slot-scope="scope">
                    <el-button v-if="!inListAccessories(scope.row.id)" @click="addProduct(scope.row)" type="success" icon="el-icon-plus" size="mini"></el-button>
                </template>
            </el-table-column>
        </el-table>
        <hr>
        <h5 class="mb-3">Liste des accéssoires qui seront ajouter aux produits</h5>
        <el-form class="formAccessoires" ref="form" :model="form">
            <el-table v-if="false" style="width: 100%" ref="multipleTable" :data="form.products" stripe>
                <el-table-column prop="visuel">
                    <template slot-scope="scope">
                        <a v-if="scope.row.images.length" href="#" class="mb-3">
                            <span class="avatar" :style="{backgroundImage: 'url(\'/ic/thumbnail/'+scope.row.images[0].path+'\')'}"></span>
                        </a>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="Titre">
                </el-table-column>
                <el-table-column prop="ean13" label="Code barre">
                    <template slot-scope="scope">
                        {{ scope.row.ean13 }}
                    </template>
                </el-table-column>
                <el-table-column prop="external_ref" label="Référence fournisseur">
                    <template slot-scope="scope">
                        {{ scope.row.external_ref }}
                    </template>
                </el-table-column>
            </el-table>

            <el-table style="width: 100%" :data="accessories" stripe>
                <el-table-column prop="visuel" width="55">
                    <template slot-scope="scope">
                        <el-badge :value="scope.row.images.length" class="item">
                            <span class="avatar"  v-if="scope.row.image" :style="{backgroundImage: 'url(\'/ic/thumbnail/'+scope.row.image.path+'\')'}"></span>
                            <span class="avatar"  v-else-if="scope.row.images.length" :style="{backgroundImage: 'url(\'/ic/thumbnail/'+scope.row.images[0].path+'\')'}"></span>
                            <span class="avatar"  v-else></span>
                        </el-badge>
                    </template>
                </el-table-column>
                <el-table-column prop="shop_id" label="Ref Speedway / ID" sortable="custom">
                    <template slot-scope="scope">
                        {{ scope.row.shop_id }}
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="Titre" sortable="custom" width="200">
                    <template slot-scope="scope">
                        <span v-if="scope.row.feature_type">[{{scope.row.feature_type}}] </span>{{ scope.row.name }}
                    </template>
                </el-table-column>
                <el-table-column prop="external_ref" label="Ref fournisseur" sortable="custom" >
                    <template slot-scope="scope">
                        {{ scope.row.mf_prefixe }} / {{ scope.row.external_ref }}
                        <span v-if="scope.row.base_ref">
                            <br>
                            ({{ scope.row.base_ref }}<template v-if="scope.row.color_code"> / {{scope.row.color_code}}</template>)
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="actions" >
                    <template slot-scope="scope">
                        <el-button  @click="removeProduct(scope.row.id)" type="danger" icon="el-icon-delete" size="mini"></el-button>
                    </template>
                </el-table-column>
            </el-table>

        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-input-number v-model='position' :min='1' :step='1' placeholder="Position de l'accessoire (1 étant au début)"></el-input-number>
            <el-switch active-text='Ajouter à la fin de la liste' v-model="addToEnd" ></el-switch>
            <el-switch active-text="Remplace les accessoires existant ?" v-model="form.overide" ></el-switch>
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { EventBus } from '../../../event-bus';
export default {
    data() {
        return {
            display: false,
            loader: false,
            loading: false,
            error: false,
            errorMessage: null,
            form: {
                products: [],
                overide: false,
            },
            q: null,
            accessories: [],
            finded: [],
            addToEnd: false,
            position: 1,
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        },
        hasProductMaster() {
            return this.form.products.filter(
                v => v.datasEditInline.productMaster
            ).length
                ? true
                : false;
        },
        productMaster() {
            return this.form.products.find(
                v => v.datasEditInline.productMaster
            );
        },
        productMasterId() {
            var p = this.form.products.filter(
                v => v.datasEditInline.productMaster
            );
            if (p.length) {
                return p[0].id;
            }
            return null;
        },
    },
    methods: {
        open() {
            this.form.products = Array.from(this.selected);
            this.form.products.forEach((v,k) => {
                v.populateEditMode();
            });
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
            this.finded = [];
            this.accessories = [];
            this.form.overide = false;
        },
        action() {
            let datas = {
                products: [],
                accessories: [],
                mode: 'accessories',
                overide: this.form.overide,
                position: this.position,
            };
            this.form.products.forEach(v => {
                datas.products.push(v.id);
            });
            this.accessories.forEach(v => {
                datas.accessories.push(v.id);
            });
            this.error = false;
            this.errorMessage = null;
            if (!this.accessories.length) {
                this.error = true;
                this.errorMessage = 'Merci de choisir des accessoires.';
                return;
            }
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected
            datas.addToEnd = this.addToEnd

            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }

            this.$confirm('Ajouter les accessoires ?', 'Attention', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler',
                type: 'warning'
            })
                .then(() => {
                    this.loader = true;
                    axios
                        .post(
                            '/products/bulk',
                            datas
                        )
                        .then(r => {
                            this.form.products = [];
                            this.display = false;
                            EventBus.$emit('products.list.refresh');
                        })
                        .catch(() => {})
                        .then(() => {
                            this.loader = false;
                        });
                })
                .catch(() => {});
        },
        inListAccessories(id)
        {
            return this.accessories.filter(v=>v.id == id).length
        },
        search()
        {
            var excluded = this.accessories.map(v => v.id);
            excluded.push(this.productId);
            var excludedString = excluded.join(',')
            var params = {
                exclude_products: excludedString,
                q: this.q,
                filterListShopId: true,
                filterListRef: true,
            }
            this.loading = true
            axios.get('/search', {params}).then(r => {
                this.finded = r.data.data
            }).catch(r=>{

            }).then(()=>{
                this.loading = false
            })
        },
        reset()
        {
            this.q = null;
            this.finded = [];
        },
        addProduct(product)
        {
            this.accessories.push(product)
        },
        removeProduct(id)
        {
            let index = this.accessories.findIndex((v)=>{
                return v.id == id;
            })
            this.accessories.splice( index, 1)
        },
        addAll()
        {
            let filtred = this.finded.filter( v => !this.accessories.find( vv => vv.id != v.id ) );
            filtred.forEach(v => this.accessories.push(v));
        }
    }
};
</script>
